export class IndividualUserToken {
  static IIndividualUserRepository = Symbol("IIndividualUserRepository");
  static IndividualUserUseCase = Symbol("IndividualUserUseCase");
  static IndividualUsersManagementViewModel = Symbol(
    "IndividualUsersManagementViewModel",
  );
}
